'use es6';

import { isElement, isShadowRoot } from '@floating-ui/utils/dom';
export function activeElement(doc) {
  let element = doc.activeElement;
  while (((_element = element) === null || _element === void 0 || (_element = _element.shadowRoot) === null || _element === void 0 ? void 0 : _element.activeElement) != null) {
    var _element;
    element = element.shadowRoot.activeElement;
  }
  return element;
}
export function contains(parent, child) {
  var _child$getRootNode;
  if (!parent || !child) {
    return false;
  }
  const rootNode = (_child$getRootNode = child.getRootNode) === null || _child$getRootNode === void 0 ? void 0 : _child$getRootNode.call(child);

  // First, attempt with the faster native method.
  if (parent.contains(child)) {
    return true;
  }

  // Then fall back to traversing out of shadow roots when needed.
  if (rootNode && isShadowRoot(rootNode)) {
    let next = child;
    while (next) {
      if (parent === next) {
        return true;
      }
      next = next.parentNode || next.host;
    }
  }
  return false;
}

/**
 * Finds the closest matching element in the composed tree, crossing slots and shadow roots.
 * `:scope` is not supported.
 */

export function closest(node, selector) {
  let current = node;
  while (current) {
    var _ref, _current$assignedSlot;
    if (isElement(current) && current.matches(selector)) {
      return current;
    }
    current = (_ref = (_current$assignedSlot = current.assignedSlot) !== null && _current$assignedSlot !== void 0 ? _current$assignedSlot : current.parentNode) !== null && _ref !== void 0 ? _ref : isShadowRoot(current) ? current.host : null;
  }
  return null;
}
export function getTarget(event) {
  if ('composedPath' in event) {
    var _event$composedPath$;
    // The composed path is empty once the event is no longer being dispatched,
    // so fall back to `target` for handlers running after dispatch completes.
    return (_event$composedPath$ = event.composedPath()[0]) !== null && _event$composedPath$ !== void 0 ? _event$composedPath$ : event.target;
  }

  // TS assumes `composedPath()` always exists, but older browsers without
  // shadow DOM support still fall back to `target`.
  return event.target;
}